import React from 'react';
import logo from '../static/logo_white_black.png';

export default function Logo(props) {
    

  return (
    <img src={logo} {...props} ></img>
  );
}